/**
 * LatestInsights — Sprint 17 · SEO additive homepage module.
 *
 * Placed above the footer on Home.jsx. Pulls the 4 most-recent items from
 * trendsPosts and links to /trends/{id}. Does not modify or replace any
 * existing section. Purely additive.
 */
import { Link } from "react-router-dom";
import { trendsPosts } from "@/data/trends";

const parseDate = (d) => (d ? new Date(d).getTime() : 0);

export const LatestInsights = () => {
  const posts = [...(trendsPosts || [])]
    .sort((a, b) => parseDate(b.datePublished) - parseDate(a.datePublished))
    .slice(0, 4);
  if (posts.length === 0) return null;
  return (
    <section
      aria-labelledby="latest-insights-heading"
      data-testid="home-latest-insights"
      style={{
        padding: "5rem 1.5rem 4rem",
        background: "var(--paper-raised, #F1EBDE)",
        borderTop: "1px solid var(--line, rgba(26,23,20,.14))",
      }}
    >
      <div style={{ maxWidth: 1240, margin: "0 auto" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: "2rem", gap: "1rem", flexWrap: "wrap" }}>
          <div>
            <p className="mono" style={{ fontSize: ".7rem", letterSpacing: ".16em", color: "var(--brass-deep, #8A6526)", textTransform: "uppercase", margin: "0 0 .5rem" }}>
              Latest insights
            </p>
            <h2 id="latest-insights-heading" className="display" style={{ fontSize: "clamp(1.6rem, 3vw, 2.2rem)", letterSpacing: "-.01em", margin: 0, maxWidth: "38ch" }}>
              Practical India-sourcing writing from the buyer-side floor.
            </h2>
          </div>
          <Link to="/trends" data-testid="home-latest-insights-all" className="btn btn-ghost" style={{ padding: ".55rem 1.1rem", fontSize: ".9rem", whiteSpace: "nowrap" }}>
            All insights →
          </Link>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: "1.2rem" }}>
          {posts.map((p) => (
            <article key={p.id} data-testid={`home-latest-insights-item-${p.id}`} style={{ background: "var(--paper, #F6F2E9)", border: "1px solid var(--line, rgba(26,23,20,.14))" }}>
              <Link to={`/trends/${p.id}`} style={{ display: "block", textDecoration: "none", color: "inherit" }}>
                {p.image && (
                  <img
                    src={p.image}
                    alt={p.imageAlt || p.title}
                    loading="lazy"
                    style={{ width: "100%", aspectRatio: "16/10", objectFit: "cover", display: "block", background: "#e8e1d1" }}
                  />
                )}
                <div style={{ padding: "1.2rem 1.3rem 1.4rem" }}>
                  <p className="mono" style={{ fontSize: ".62rem", letterSpacing: ".14em", color: "var(--brass-deep, #8A6526)", textTransform: "uppercase", margin: "0 0 .5rem" }}>
                    {p.categoryLabel || p.category} · {p.readTime || "read"}
                  </p>
                  <h3 style={{ fontFamily: "var(--display, Georgia, serif)", fontSize: "1.05rem", lineHeight: 1.35, letterSpacing: "-.005em", margin: "0 0 .6rem", color: "var(--ink, #1A1714)" }}>
                    {p.title}
                  </h3>
                  {p.excerpt && (
                    <p style={{ margin: 0, fontSize: ".88rem", lineHeight: 1.55, color: "var(--ink-soft, #3C362F)" }}>
                      {p.excerpt.length > 130 ? `${p.excerpt.slice(0, 130)}…` : p.excerpt}
                    </p>
                  )}
                </div>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LatestInsights;
